<script lang="ts">
    import Swal from "sweetalert2";


    export let title = "" as string;
    export const submit_type = "" as string;
    export let on_click_func = undefined;
    export let disabled = undefined;
</script>
<button class={`button ${disabled ? 'disabled' : ''}`} on:click={on_click_func ? on_click_func : () => {}} disabled={disabled}>
    {title}
</button>
<style>
    .button {
        padding: 10px 20px;
        font-size: 16px;
        font-weight: 500;
        background-color: #BCD570;
        font-family: "Montserrat";
        border: none;
        outline: none;
        border-radius: 4px;
        color: #000;
        min-height: 45px;
        cursor: pointer;
    }
    .button:hover {
        background-color: yellowgreen;
    }
    @media (max-width: 500px) {
        .button {
            font-size: 14px;
            min-height: 35px;
        }
    }
    .disabled {
        pointer-events: none;
        cursor: not-allowed;
        opacity: 0.8;
    }
</style>